import React, { useEffect, useRef, useState } from "react";
import logo from "../../assets/images/logo.png";
import avt from "../../assets/images/Default_user_image.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "../../API/axios";
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";

import logo2 from "../../assets/images/logo2.png";
import defaultImage from "../../assets/images/Default_user_image.png";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import DeleteForeverSharpIcon from "@mui/icons-material/DeleteForeverSharp";
import LogoutSharpIcon from "@mui/icons-material/LogoutSharp";
import WorkSharpIcon from "@mui/icons-material/WorkSharp";
import WorkHistorySharpIcon from "@mui/icons-material/WorkHistorySharp";
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp";
import GobalSearch from "../../khojpages/GlobalSearch/GobalSearch";
import TopNotification from "./TopNotification";
// import { set } from "react-datepicker/dist/date_utils";
import CachedIcon from '@mui/icons-material/Cached';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import toast from "react-hot-toast";
import { Accordion, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import moment from "moment";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Tooltip from "@mui/material/Tooltip";

LoginHeader.propTypes = {};

function LoginHeader({ clname = "", handleMobile }) {
	const [isDark, setIsDark] = useLocalStorage("isDark", false);
	const [activeIndex, setActiveIndex] = useState(null);
	//   const [inputValue, setInputValue] = useState("");

	const handleDropdown = (index) => {
		setActiveIndex(index);
	};

	const [scroll, setScroll] = useState(0);

	useEffect(() => {
		document.addEventListener("scroll", () => {
			const scrollCheck = window.scrollY > 100;
			if (scrollCheck !== scroll) {
				setScroll(scrollCheck);
			}
		});
	}, []);

	// ..................................................................................
	// ..................................................................................
	// Get the sessionId from localStorage
	const sessionId = localStorage.getItem("sessionId");
	const token = localStorage.getItem("token");
	const userUID = localStorage.getItem("userUID");
	// const userCandData = JSON.parse(localStorage.getItem('userCandData'));
	// console.log("userCandData", userCandData);
	console.log("token", token);

	const [notifi, setNotifi] = useState([]);
	const [notifiCount, setNotifiCount] = useState("");

	// Async function to get the top 5 notifications
	const NotificationList = async () => {
		const data = {
			deviceType: "Web",
			sessionId: sessionId, // sessionId from localStorage
		};

		try {
			// Make the POST request to the server
			const resData = await axios.post(`V1/General/GetTop5Notifications`, data);

			// Log the response data to the console
			console.log("Response Data:", resData.data.responseData);

			// Set the notifications state with the response data
			setNotifi(resData.data.responseData);

			// Optionally, log the state update to check if notifications were set correctly
			console.log("Notifications after set:", notifi);
		} catch (error) {
			// Handle error if the server returns a 404 status
			if (error.response && error.response.status === 404) {
				console.log("Error 404: Not Found");
			} else {
				// Log any other error
				console.log(error);
			}
		}
	};

	const entityName = localStorage.getItem("entityName");
	const firstName = localStorage.getItem("firstName");
	const lastName = localStorage.getItem("lastName");
	const email = localStorage.getItem("email");
	const userType = localStorage.getItem("userType");

	// const profilPic = localStorage.getItem("profilPic");

	const [profilPic, setProfilePic] = useState("");

	console.log("profilPic", profilPic);


	useEffect(() => {
		const savedImage = localStorage.getItem("ProfileImage");
		// const username = localStorage.getItem("ProfileImage");
		if (savedImage) {
			setProfilePic(savedImage);
		}
	}, []);

	// ........................................................................
	// ........................................................................

	const [profileStatus, setProfileStatus] = useState(false);
	console.log('profileStatus:', profileStatus);

	const checkProfile = async () => {
		const data = { sessionId: sessionId };
		try {
			const response = await axios.post("/CandidateData/Check", data);
			const profileExists = response.data.responseData;

			setProfileStatus(profileExists);
		} catch (error) {
			if (error.response && error.response.status === 400) {
				// toast.error(error.response.message)
				console.log("data", error.response.status);

				// setIsError(true);
			} else {
				console.log(error);
			}
			console.error("Error fetching profile status:", error);
			return false;
		}
	};

	useEffect(() => {
		checkProfile();
	}, []);

	// ........................................................................
	//                             SearchModal 
	// ........................................................................

	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);


	// ........................................................................
	//                             SearchModal 
	// ........................................................................

	const navigate = useNavigate();
	const location = useLocation();

	const handleNavigation = (path) => {
		if (location.pathname === path) {
			window.location.reload(); // Force a full page reload
		} else {
			navigate(path);
		}
	};

	// const handleCopy = async () => {
	// 	try {
	// 		const userCandData = JSON.parse(localStorage.getItem("userCandData"));

	// 		// Check if it's an array and has at least one object
	// 		if (Array.isArray(userCandData) && userCandData.length > 0) {
	// 			const linkToCopy = userCandData[0].link;

	// 			if (!linkToCopy) {
	// 				toast.warning("No link found");
	// 				return;
	// 			}

	// 			await navigator.clipboard.writeText(linkToCopy);
	// 			// alert("Copied: " + linkToCopy);
	// 			toast.success("Copied");

	// 		} else {
	// 			alert("User Candidate Data is empty or invalid.");
	// 		}
	// 	} catch (error) {
	// 		alert("Error while copying link.");
	// 		console.error(error);
	// 	}
	// };

	const handleCopy = (link) => {
		navigator.clipboard.writeText(link)
			.then(() => {
				toast.success("Link copied")
			})
			.catch((err) => {
				toast.error("Link not available")
			});
	};

	const [candidateData, setCandidateData] = useState([]);
	const getAssignedTests = async () => {
		try {
			const response = await axios.post(
				'/Candidate/GetAssignedTests',
				{
					sessionId: sessionId
				},
				{
					headers: {
						Authorization: token,
					},
				}
			);
			console.log("response=====>", response.data.responseData);
			setCandidateData(response.data.responseData);
			// toast.success("Test candidates list refreshed");
		} catch (err) {
			console.log("error", err);

			// toast.error(err.data.message);
		}
	};
	console.log("candidateData", candidateData);

	useEffect(() => {
		const fetchInterval = setInterval(() => {
			getAssignedTests();
		}, 3600000);
		getAssignedTests();
		return () => clearInterval(fetchInterval);
	}, []);

	const [activeKey, setActiveKey] = useState(null);
	const accordionRef = useRef(null);

	const handleClickOutside = (event) => {
		if (accordionRef.current && !accordionRef.current.contains(event.target)) {
			setActiveKey(null); // Close accordion
		}
	};

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const truncateText = (text, maxLength) => {
		if (!text) return '';
		return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
	};

	return (
		<>
			<header
				id="header"
				className={`header khojdesktopHeader pt-3 header-default loginkhojHeader`}
			>
				<div className="px-4 ct2">
					<div className="row">
						<div className="col-md-12">
							<div className="sticky-area-wrap">
								<div className="header-ct-left">
									{isDark ? (
										<div id="logo" className="logo">
											<Link to="/Home" onClick={() => handleNavigation("/Home")}>
												<img
													className="site-logo"
													id="trans-logo"
													src={logo2}
													alt="Image"
												/>
											</Link>
										</div>
									) : (
										<div id="logo" className="logo">
											<Link to="/Home" onClick={() => handleNavigation("/Home")}>
												<img
													className="site-logo"
													id="trans-logo"
													src={logo}
													alt="Image"
												/>
											</Link>
										</div>
									)}
								</div>
								{/* <div className="gloabl-search-container">
									<GobalSearch />
									</div> */}
								<div className="form-group-1 khojSearch d-flex align-items-center">
									<GobalSearch />
								</div>
								<div className="header-ct-center">
									<div className="nav-wrap">
										<nav id="main-nav" className="main-nav">
											<ul
												id="menu-primary-menu"
												className={`menu${clname} mb-0`}
											>

												<li className="menu-item subjob">
													{/* <Link to="/AllJobs" >
														<WorkSharpIcon />
													</Link>
									 				<NavLink to="/AllJobs" >Search Job</NavLink> */}
													<Link to="/Jobs" >
														<WorkSharpIcon />
													</Link>
													<NavLink to="/Jobs" >Jobs</NavLink>
												</li>
												<li className="menu-item menu-item-has-children sub4">
													<Link>
														<WorkHistorySharpIcon />
													</Link>
													<Link to="#">Manage Job</Link>

													<ul className="dropdown-menu sub-menu st1">
														<Link to="/Saved-jobs"  >
															<li className="dropdown-item ">
																<Link to="/Saved-jobs" >Saved Jobs</Link>
															</li>
														</Link>
														<Link to="/Applied-jobs"  >
															<li className="dropdown-item ">
																<NavLink to="/Applied-jobs">Applied Jobs</NavLink>
															</li>
														</Link>
													</ul>
												</li>

											</ul>
										</nav>
									</div>
								</div>



								<div className="header-ct-right">
									<Toggle
										isChecked={isDark}
										handleChange={() => setIsDark(!isDark)}
									/>

									<TopNotification />

									<div className="nav-wrap">
										<nav id="main-nav" className="main-nav profileNav">
											<ul
												id="menu-primary-menu"
												className={`menu ps-0 ms-3 profileMenu mb-2 ${clname} `}
											>
												<li className="menu-item menu-item-has-children profile-img m-0">
													{
														!profilPic ?
															<div className="profile-image-container">
																{/* <Link to="#"> */}
																<img
																	src={defaultImage}
																	width={40}
																	// alt="User Logo"
																	className="userProfileHeader"
																/>
																{/* </Link> */}
															</div>
															:
															<div className="profile-image-container">
																{/* <Link to="#"> */}
																<img
																	src={profilPic}
																	// width={40}
																	alt="User Logo"
																	className="userProfileHeader"
																/>
																{/* </Link> */}
															</div>
													}


													<div className="header-customize-item bell pro  ">
														<div className="sub-notification profile">
															<div className="tabs row">
																<li>
																	<div className=" d-flex HeaderFLName">
																		<h6>
																			{" "}
																			{`${entityName} `}
																			{/* {firstName} {lastName} */}
																		</h6>
																	</div>
																	<div className="HeaderEmail">
																		<h6> {email}</h6>
																	</div>
																	<div className="HeaderUserType">
																		<h6> {userType}</h6>
																	</div>
																</li>

																<li className="nav-sub">
																	<AccountCircleSharpIcon />
																	{profileStatus ? <Link to={`/Resume/Candidate?userUID=${userUID}`}  >Profile</Link> :
																		<Link to="/Candidate">Complete Profile</Link>
																	}
																</li>

																<li className="nav-sub">
																	<SettingsSharpIcon />
																	<NavLink to="/Settings">Settings</NavLink>
																</li>
																<li className="nav-sub">
																	<LogoutSharpIcon />

																	<NavLink
																		to="/Login"
																		onClick={() => {
																			const isDarkValue = localStorage.getItem('isDark'); // Store the value of isDark
																			localStorage.clear(); // Clear all localStorage
																			if (isDarkValue !== null) {
																				localStorage.setItem('isDark', isDarkValue); // Restore the isDark key if it exists
																			}
																		}}
																	>
																		Logout
																	</NavLink>
																</li>
															</div>
														</div>
													</div>
												</li>
											</ul>
										</nav>
									</div>
								</div>
								<div className="nav-filter" onClick={handleMobile}>
									<div className="nav-mobile">
										<span></span>
									</div>
								</div>
							</div>
						</div>
						<div ref={accordionRef} className="col-md-12 p-0 accordian-container">
							{candidateData && candidateData.length > 0 && (
								<div className="col-md-12 p-0 accordian-container">
									<Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
										<Accordion.Item eventKey="0">
											<Accordion.Header>
												<span className="test-candidate-header me-3">Assigned test  <span className="ms-2">({candidateData.length})</span></span>
												<span>
													<CachedIcon
														onClick={(e) => {
															e.preventDefault();
															e.stopPropagation();
															getAssignedTests();
														}}
													/>
												</span>
											</Accordion.Header>
											<Accordion.Body>
												{/* <div className="d-flex">
													{candidateData.map((data) => (
														<div key={data.cnddtstId} className="d-flex flex-column test-candidate-cont p-2 me-2">
															<ul className="test-candidate-data ps-1 mb-0">
																<li>
																	<span className="f-600 f-15">Test Name: </span>
																	<span className="textColor f-15">{data.testName}</span>
																</li>
																<li className="mb-1">
																	<span className="f-600 f-15">Schedule At: </span>
																	<span className="textColor f-15">
																		{moment.utc(data.scheduledAt).local().format("DD MMM YYYY - hh:mm A")}
																	</span>
																</li>
																<li>
																	<span className="f-600 f-15">Test Duration: </span>
																	<span className="textColor f-15"> {data.testDurationMinutes} Minutes</span>
																</li>
																<li className="d-flex">
																	<span className="f-600 f-15">Test Link: </span>
																	<Tooltip
																		title={
																			<a
																				href={data.link}
																				target="_blank"
																				rel="noopener noreferrer"
																				onClick={(e) => e.stopPropagation()} // optional, to avoid bubbling
																				style={{ color: '#fff', textDecoration: 'underline' }}
																			>
																				{data.link}
																			</a>
																		}
																		arrow
																	>
																		<span>
																			<Button
																				className="mainBtn apply-job me-2 ms-1 f-14 py-1 view-test-link view-link"
																			// No onClick here – button doesn't do anything
																			>
																				View
																			</Button>
																		</span>
																	</Tooltip>

																	<span>
																		<Button
																			onClick={() => handleCopy(data.link)}
																			className="mainBtn apply-job me-2 f-14 py-1 view-test-link"
																		>
																			Copy
																		</Button>
																	</span>

																	<span>
																		<Button
																			onClick={() => window.open(data.link, '_blank')}
																			className="mainBtn apply-job f-14 py-1 view-test-link"
																		>
																			Open
																		</Button>
																	</span>

																</li>
															</ul>
														</div>
													))}
												</div> */}

												<div className="row" style={{ maxHeight: '400px', overflowY: 'auto' }}>
													{candidateData.map((data) => (
														<div key={data.cnddtstId} className="col-md-3 mb-3" style={{ verticalAlign: 'top' }}>
															<div className="d-flex flex-column test-candidate-cont px-1 py-2 h-100">
																<ul className="test-candidate-data ps-1 mb-0 p-0">
																	<li>
																		<span className="f-600 f-14">Test Name: </span>
																		<span className="textColor f-14">
																			{/* {data.testName} */}
																			<span className="year"
																				onClick={(e) => e.preventDefault()}>
																				{truncateText(data.testName, 25)}
																			</span></span>
																	</li>
																	<li>
																		<span className="f-600 f-14">Schedule At: </span>
																		<span className="textColor f-14">
																			{moment.utc(data.scheduledAt).local().format("DD MMM YYYY - hh:mm A")}
																		</span>
																	</li>
																	<li>
																		<span className="f-600 f-14">Test Duration: </span>
																		<span className="textColor f-14"> {data.testDurationMinutes} Minutes</span>
																	</li>
																	<li className="d-flex flex-wrap">
																		<span className="f-600 f-14">Test Link: </span>
																		<Tooltip
																			title={
																				<a
																					href={data.link}
																					target="_blank"
																					rel="noopener noreferrer"
																					onClick={(e) => e.stopPropagation()}
																					style={{ color: '#fff', textDecoration: 'underline' }}
																				>
																					{data.link}
																				</a>
																			}
																			arrow
																		>
																			<span>
																				<Button className="mainBtn apply-job me-1 ms-1 f-14 py-1 view-test-link view-link">
																					View
																				</Button>
																			</span>
																		</Tooltip>
																		<span>
																			<Button
																				onClick={() => handleCopy(data.link)}
																				className="mainBtn apply-job me-1 f-14 py-1 view-test-link"
																			>
																				Copy
																			</Button>
																		</span>
																		<span>
																			<Button
																				// onClick={() => window.open(data.link, '_blank')}
																				onClick={() => {
																					const url = data.link.startsWith('http') ? data.link : `https://${data.link}`;
																					window.open(url, '_blank');
																				}}
																				className="mainBtn apply-job f-14 py-1 view-test-link"
																			>
																				Open
																			</Button>
																		</span>
																	</li>
																</ul>
															</div>
														</div>
													))}
												</div>

											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</div>
							)}
						</div>



					</div>
				</div>
			</header>

			<header
				id="header"
				className={`header khojmobileHeader pt-3 header-default loginkhojHeader header-fixed ${scroll ? "is-fixed is-small" : ""
					}`}
			>
				<div className="px-4 ct2">
					<div className="row">
						<div className="col-md-12">
							<div className="sticky-area-wrap">
								<div className="header-ct-left">
									<div className="nav-wrap">
										<nav id="main-nav" className="main-nav profileNav">
											<ul
												id="menu-primary-menu"
												className={`menu profileMenu mb-2 ${clname} Nav-Header-Mobile mt-1`}
											>
												<li className="menu-item menu-item-has-children">

													<div className="nav-filter" onClick={handleMobile}>
														<div className="nav-mobile">
															<span></span>
														</div>
													</div>

												</li>
											</ul>
										</nav>
									</div>
								</div>
								<div className="form-group-1 khojSearch d-flex align-items-center">
									<GobalSearch />

								</div>


								<div className="header-ct-right">
									<TopNotification />
									<div className="ms-auto me-2 mobileToggle">
										<Toggle
											isChecked={isDark}
											handleChange={() => setIsDark(!isDark)}
										/>
									</div>
									{/* <div className="nav-filter" onClick={handleMobile}>
										<div className="nav-mobile">
											<span></span>
										</div>
									</div> */}
								</div>
							</div>
						</div>


					</div>
				</div>
			</header>

			{/* Modal for Search-Mobile*/}
			<Modal
				open={open}
				aria-labelledby="search-modal-title"
				aria-describedby="search-modal-description"
				className="search-modal-inner-description"
			>
				<Box
					className="search-modal-inner-description"
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						bgcolor: "background.paper",
						border: "2px solid #000",
						boxShadow: 24,
						borderRadius: "8px",
					}}
				>
					<div className="Search-Mobile-Responsive-Title d-flex ">
						<h2 id="search-modal-title" style={{ marginBottom: "16px" }}>
							Search
						</h2>
						<CloseIcon className="CloseIcon-Search-Mobile" onClick={handleClose} />
					</div>

					{/* GobalSearch Component */}
					<div id="search-modal-description" className="GobalSearch-search-modal">
						<GobalSearch />
					</div>
				</Box>
			</Modal>



		</>
	);
}

export default LoginHeader;
